import React from 'react';
import './index.css';
import LcIconLink from '../../../components/Generic/LcIconLink';
import LcIcon from '../../../components/Generic/LcIcon';

interface Props {
    list: string[],
    handleClickItem: Function,
    optionColumns?: any,
    selectedGroups?: any,
}

const AttendenceMoreResults: React.FC<Props> = (props) => {
    return (
        <div style={{ fontSize: "18px" }}>
            {
                props.list.map((item: any, index: number) => {
                    return (
                        <div key={index} className={"divOrderMoreResults"}>
                            <span
                                className='spanMoreResults'
                                onClick={() => props.handleClickItem(item)}
                            > {item.label} </span>
                            {/* {
                                props.optionColumns != null &&
                                <>
                                    {
                                        props.optionColumns[item.value] == true &&
                                        <div className={"divOrderIconCheck"}>
                                            <LcIcon icon={"ppi ppi-check"} size={'small'} />
                                        </div>
                                    }
                                </>
                            } */}
                            {/* {
                                props.selectedGroups != null && */}
                            <>
                                {
                                    props.selectedGroups[item.value] == true &&
                                    <div className={"divOrderIconCheckMoreResults"}>
                                        <LcIcon icon={"ppi ppi-check"} size={'small'} />
                                    </div>
                                }
                            </>
                            {/* } */}
                            <div className={"divOrderIconMoreResults"}>
                                {/* <LcIconLink icon={"ppi ppi-chevron-right"} onClick={() => props.handleClickItem(item)} /> */}
                                {/* <LcIconLink icon={(!props.selectedGroups[item.value]) ? "ppi ppi-plus" : "ppi ppi-minus"} onClick={() => props.handleClickItem(item)} /> */}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
};

export default AttendenceMoreResults;